export default __webpack_public_path__ + "static/media/Monk's Gloves of Balance.c6ab8c90.jpg";